import styled from 'styled-components';

export const Form = styled.form`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const FormControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.7rem;

  &:first-child {
    margin-top: 1rem;
  }
`;

export const Label = styled.label`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.4rem;

  & span {
    color: red;
  }
`;

export const Input = styled.input`
  padding: 1rem;
  font-size: 1.6rem;
  border-radius: 0.5rem;
  border: 1px solid #ddd;
  outline: transparent;
  transition: all 0.2s;

  &:focus {
    outline: 1px solid #ccc;
  }
`;

export const Textarea = styled.textarea<{ error: boolean }>`
  padding: 1rem;
  min-height: 150px;
  font-size: 1.6rem;
  font-family: inherit;
  line-height: 1.5;
  border-radius: 0.5rem;
  border: 1px solid ${({ error }) => (error ? 'red' : '#ddd')};
  outline: transparent;
  transition: all 0.2s;
  resize: none;

  &:focus {
    outline: 1px solid #ccc;
  }
`;

export const Button = styled.button<{ disabled?: boolean }>`
  width: 14rem;
  height: 3.5rem;
  display: grid;
  place-items: center;
  background-color: ${({ disabled }) => (disabled ? '#ccc' : '#D34612')};
  color: white;
  font-size: 1.3rem;
  font-weight: 600;
  border-radius: 0.6rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  text-transform: uppercase;

  &:hover {
    background-color: ${({ disabled }) => (disabled ? '#ccc' : '#C8370F')};
  }

  @media (max-width: 768px) {
    &:active {
      background-color: ${({ disabled }) => (disabled ? '#ccc' : '#C8370F')};
    }
  }
`;

export const ErrorContainer = styled.div`
  color: red;
  font-size: 1.4rem;
  padding-left: 0.5rem;

  & > p {
    margin: 0;
  }
`;
